import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './AdminLayout.css';
import { Logo } from '../Logo';

export const AdminLayout: React.FC = () => {
	const { user, logout } = useAuth();
	const navigate = useNavigate();

	const handleLogout = () => {
		logout();
		navigate('/');
	};

	return (
		<div className='admin-layout'>
			<header className='admin-header'>
				<div className='admin-header-content'>
					<Logo size='small' />

					<nav className='admin-nav'>
						<NavLink to='/admin' end className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
							Početna
						</NavLink>
						<NavLink to='/admin/surveys' className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
							Upitnici
						</NavLink>
						<NavLink to='/admin/users' className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
							Korisnici
						</NavLink>
						<NavLink to='/admin/smtp' className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
							Email Config
						</NavLink>
						{/* <NavLink to='/admin/reports' className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
							Prijave
						</NavLink> */}
					</nav>

					<div className='admin-user-menu'>
						<div className=''>
							<span className='user-name'>{user && (user?.type === 'admin' ? user.email : `${user} ${user.lastName}`)}</span>
						</div>
						<button onClick={handleLogout} className='logout-btn' title='Odjavite se'>
							Odjava
						</button>
					</div>
				</div>
			</header>

			<main className='admin-main'>
				<Outlet />
			</main>
		</div>
	);
};
